import React from 'react';
import './ShowPlace.css';

import AboutMe from './category/AboutMe';
import Works from './category/Works';
// import Links from './category/Links';
// import Contact from './category/Contact';
import LinksAndContact from './category/LinksAndContact';

function ShowPlace({
    showBlueScreen,
    showAboutMeModal, showWorksModal, showLinksModal, showContactModal,
    setShowAboutMeModal, setShowWorksModal, setShowLinksModal, setShowContactModal,
    currentAboutMeIcon, currentWorksIcon, currentLinksIcon, currentContactIcon,
    handleFolderDoubleClick, handleBackToMenuClick,
    showLinksAndContactModal,setShowLinksAndContactModal, currentLinksAndContactIcon,
    resetIcons
}) {

    return (
        <div className={`blue-screen ${showBlueScreen ? 'show' : ''}`}>
            {showBlueScreen && (
                <div className="folder-container">
                    <img
                        src={currentAboutMeIcon}
                        alt="current-about-me-icon"
                        style={{
                            width: "150px",
                            height: "auto",
                            marginBottom: "50px"
                        }}
                        onClick={() => handleFolderDoubleClick('aboutMe')}
                        onDoubleClick={() => handleFolderDoubleClick('aboutMe')}
                    />
                    <img
                        src={currentWorksIcon}
                        alt="current-works-icon"
                        style={{
                            width: "140px",
                            height: "auto",
                            marginBottom: "50px"
                        }}
                        onClick={() => handleFolderDoubleClick('works')}
                        onDoubleClick={() => handleFolderDoubleClick('works')}
                    />
                    {/* <img
                        src={currentLinksIcon}
                        alt={"current-links-icon"}
                        style={{
                            width: "140px",
                            height: "auto",
                            marginBottom: "50px"
                        }}
                        onClick={() => handleFolderDoubleClick('links')}
                        onDoubleClick={() => handleFolderDoubleClick('links')}
                    />
                    <img
                        src={currentContactIcon}
                        alt={"current-contact-icon"}
                        style={{
                            width: "140px",
                            height: "auto"
                        }}
                        onClick={() => handleFolderDoubleClick('contact')}
                        onDoubleClick={() => handleFolderDoubleClick('contact')}
                    /> */}
                    <img
                        src={currentLinksAndContactIcon}
                        alt={"current-links-contact-icon"}
                        style={{
                            width: "140px",
                            height: "auto",
                            marginBottom: "50px"
                        }}
                        onClick={() => handleFolderDoubleClick('linksAndContact')}
                        onDoubleClick={() => handleFolderDoubleClick('linksAndContact')}
                    />
                </div>
            )}
            <AboutMe showAboutMeModal={showAboutMeModal} setShowAboutMeModal={setShowAboutMeModal} handleBackToMenuClick={handleBackToMenuClick} resetIcons={resetIcons} />
            <Works showWorksModal={showWorksModal} />
            {/* <Links showLinksModal={showLinksModal} setShowLinksModal={setShowLinksModal} handleBackToMenuClick={handleBackToMenuClick} /> */}
            {/* <Contact showContactModal={showContactModal} setShowContactModal={setShowContactModal} handleBackToMenuClick={handleBackToMenuClick} /> */}
            <LinksAndContact showLinksAndContactModal={showLinksAndContactModal} setShowLinksAndContactModal={setShowLinksAndContactModal} currentLinksAndContactIcon={currentLinksAndContactIcon} handleBackToMenuClick={handleBackToMenuClick} resetIcons={resetIcons} />
        </div>
    )
}

export default ShowPlace;